export default __webpack_public_path__ + "static/services-details1c-cecc1793fae5cd438c1bda9249c44c69.jpg";